import axios from 'axios'
import Setting from '@/setting'
import Vue from 'vue'
// 创建一个 axios 实例
const service = axios.create({
  baseURL: Setting.apiBaseURL,
  timeout: 30000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    const token = localStorage.getItem("userinfo");
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  error => {
    // 发送失败
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    console.log('response', response)
    console.log(response.status)
    const res = response
    let _this = Vue.prototype
    if (res.status >= 200 && res.status < 300) {
      return response.data;
    } else if (res.status == 401) {
      _this.$toast.error(res.data.msg)
      return Promise.reject(response.data)
    } else {
      console.log("1111111111")
      _this.$toast.error(res.data.msg)
      return Promise.reject(response.data)
    }
  }, err => {
    let errText = ''
    if (err && err.response) {
      console.error(err)
      switch (err.response.status) {
        case 400: {
          errText = '请求错误 400'
          console.error('请求错误(400)');
        } break;
        case 401:
          // 返回401 说明refreshtoken过期 某些操作需要登录之后 所以这里打开登录弹窗并reject
          console.error(err)
          return Promise.reject(err);
        case 403: {
          errText = '拒绝访问 403'
          console.error('拒绝访问(403)');
        } break;
        case 404: {
          errText = '请求出错 404'
          console.error('请求出错(404)');
        } break;
        case 408: {
          errText = '请求超时 408'
          console.error('请求超时(408)');
        } break;
        case 500: {
          errText = '服务器错误 500'
          console.error('服务器错误(500)');
        } break;
        case 501: {
          errText = '服务未实现 501'
          console.error('服务未实现(501)');
        } break;
        case 502: {
          errText = '网络错误 502'
          console.error('网络错误(502)');
        } break;
        case 503: {
          errText = '服务不可用 503'
          console.error('服务不可用(503)');
        } break;
        case 504: {
          errText = '网络超时 504'
          console.error('网络超时(504)');
        } break;
        case 505: {
          errText = 'HTTP版本不受支持 505'
          console.error('HTTP版本不受支持(505)');
        } break;
        default: {
          errText = `连接出错(${err.response.status})!`
          console.error(`连接出错(${err.response.status})!`);
        }
      }
    } else {
      errText = '连接服务器失败！'
      console.error('连接服务器失败！')
    }
    console.error(errText)
    console.error(err);
    return Promise.reject(err);
  }
);

const request = ({ url, method, data = { }, params = { } }) => {
  return service({ url, method, data, params })
}

export default request;



// WEBPACK FOOTER //
// ./src/lib/js/request.js